import React from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';

import Banner from '../components/layout/Banner';

const useStyles = makeStyles(theme => ({
  gold: {
    color: '#fff',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#00adba',
    paddingBottom: '200px',
  },
  events: {
    marginTop: '-200px',
    paddingBottom: theme.spacing(6),
  },
  titles: {
    textAlign: 'center'
  },
  title: {
    fontWeight: 800,
    fontSize: '40px',
    color: '#fff',
    paddingTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
    maxWidth: '700px',
    margin: '0 auto'
  },
  subtitle: {
    fontWeight: 400,
    color: '#fff',
    maxWidth: '500px',
    margin: '0 auto',
    paddingBottom: theme.spacing(7),
  },
  divider: {
    maxWidth: '400px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: theme.palette.secondary.main,
    margin: '0 auto',
  },
  paragraph: {
    fontSize: '16px',
    whiteSpace: 'pre-line',
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    maxWidth: '1024px',
    margin: '0 auto',
  },
  eventtitle: {
    fontSize: '28px',
    lineHeight: '36px',
    maxWidth: '200px',
    color: theme.palette.secondary.main,
  },
  eventtime: {
    paddingTop: theme.spacing(2),
  },
  eventtext: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(1),
    minHeight: '168px',
    '& b': {
      color: theme.palette.secondary.main,
    }
  },
  card: {
    cursor: 'pointer',
    padding: theme.spacing(3)
  },
  card2: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
  },
  button2: {
    backgroundColor: '#fff',
    color: theme.palette.primary.main,
  }
}));

const Event = (props) => {
  const event = props.config;
  const classes = useStyles();
  return (
    <Card id={`card-${event.id}`} className={classes.card} onClick={(e) => props.handleClick(event.id)}>
      <div >
        <div><h2 className={classes.eventtitle}>{event.title}</h2></div>
        <div><h4 className={classes.eventtime}>{event.subtitle}</h4></div>
        <div><p className={classes.eventtext} dangerouslySetInnerHTML={{ __html: event.description}} /></div>
      </div>
      <Button variant="contained" color="primary" onClick={() => props.handleClick()} >Explore</Button>
    </Card>
  );
};

const More = (props) => {
  const url = 'https://www.aist.asn.au/Events/ASI/Additional-content';
  const handleClick = () => {
    window.open(url, '_blank');
  };
  const classes = useStyles();
  return (
    <Card id="card-more" className={`${classes.card} ${classes.card2}`} onClick={(e) => handleClick()}>
      <div >
        <div><h2 className={classes.eventtitle}>Additional<br />Content</h2></div>
        <div><h4 className={classes.eventtime}>&nbsp;</h4></div>
        <div><p className={classes.eventtext} style={{color: '#fff'}}>We understand that investments are complex and you need all the information you can get.<br/><br/>Delve deeper and explore interesting research, articles and white papers developed by our Industry Partners. </p></div>
      </div>
      <Button variant="contained" color="default" href={url} target="_blank" rel="noopener noreferrer" className={classes.button2} >Read More</Button>
    </Card>
  );
};

export default (props) => {
  const { memberId } = props.match.params;
  const history = useHistory();
  const handleClick = (memberId, id) => {
    history.push(`/${memberId}/event/${id}`);
  };
  const classes = useStyles();
  return (
    <>
      <div className={classes.gold} style={{ backgroundImage: `url('/background.gradient.png')` }}>
        <Banner userId={memberId} />
        <Container>
          <div className={classes.titles}>
            <h1 className={classes.title}>{props.config.eventPanel.title}</h1>
            <h2 className={classes.subtitle}>{props.config.eventPanel.subtitle}</h2>
            <hr className={classes.divider} />
            <p className={classes.paragraph}>{props.config.eventPanel.description}</p>
          </div>
        </Container>
      </div>
      <Container>
        <Grid container direction="row" spacing={3} className={classes.events} >
          {props.config.eventPanel.events && props.config.eventPanel.events.map((event, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Event config={event} handleClick={ () => handleClick(memberId, event.id)} />
            </Grid>
          ))}
          <Grid item xs={12} sm={6} md={4}>
            <More />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};